import { TextField, MenuItem, Avatar, SxProps } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple } from 'Images';
import { ReactNode } from 'react';

interface IControlledSelectInput2 {
  options: string[];
  value: string;
  width?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onFocus?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => void;
  ariaLabelledById?: string;
  ariaLabel?: string;
  ariaRequired?: boolean;
  label?: string;
  sx?: SxProps;
  divWrapperSx?: any;
  size: 'small' | 'medium';
  id?: string;
  endAdornment?: ReactNode;
  widthOffset?: string;
  disablePortal?: boolean;
}

export const ControlledSelectInput2 = ({
  onChange,
  options,
  value,
  width,
  onFocus,
  onBlur,
  ariaLabelledById,
  ariaLabel,
  ariaRequired,
  label,
  sx,
  divWrapperSx,
  endAdornment,
  size,
  id,
  widthOffset,
  disablePortal,
}: IControlledSelectInput2) => {
  const isDesktop = useIsDesktop();
  return (
    <TextField
      id={id?.trim().replace(' ', '-')}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      label={label}
      aria-labelledby={ariaLabelledById ? ariaLabelledById : undefined}
      select
      fullWidth={!width}
      size={size}
      InputProps={{
        endAdornment: endAdornment,
      }}
      inputProps={{
        'aria-label': ariaLabel,
        'aria-required': ariaRequired,
      }}
      sx={{
        width: width,
        borderRadius: '8px',
        bgcolor: '#fff',

        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px',
          borderColor: 'primary.shade_200',
          borderWidth: '1px',
        },
        '.MuiInputLabel-root': {
          fontWeight: 400,
        },
        '.MuiOutlinedInput-root': {
          fontWeight: 400,

          '&:hover fieldset': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
            borderWidth: '1px',
          },
        },
        '& .MuiSelect-icon': {
          cursor: 'pointer',
          top: 'auto',
        },
        '.MuiSelect-iconOpen': {
          top: 'auto',
        },
        '&.MuiFormControl-root': {
          '& div': {
            ...divWrapperSx,
          },
        },
        ...sx,
      }}
      SelectProps={{
        MenuProps: {
          disablePortal: disablePortal,
          PaperProps: {
            sx: {
              mt: isDesktop ? undefined : '2px',
              width: width,
              marginRight: widthOffset,
              padding: 0,
              color: 'text.secondary',
              borderRadius: '0 0 8px 8px',
              boxShadow: '0px 6px 12px 0px rgba(21, 82, 232, 0.06)',
              maxHeight: '200px',
              '& ul': {
                p: 0,
              },
            },
          },
        },
        IconComponent: (props) =>
          endAdornment ? (
            <></>
          ) : (
            <Avatar {...props} src={AccordionArrowPurple} alt={''} />
          ),
      }}
    >
      {options.map((value, index) => (
        <MenuItem
          key={index}
          value={value}
          sx={{
            fontWeight: 400,
            padding: '14px 0px 14px 20px',
            '&:hover': { fontWeight: 700, bgcolor: 'primary.shade_100' },
            '&.Mui-selected': {
              fontWeight: 700,
              bgcolor: 'primary.shade_100',
            },
          }}
        >
          {value}
        </MenuItem>
      ))}
    </TextField>
  );
};
